module.exports = __webpack_public_path__ + "media/images/bg/mosaic/team-7f44107e53341ddb81d93d79add9e17d.jpg";